import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'

export default {
  components: {
    vueDropzone: vue2Dropzone
  },
  methods: {
    additionalDropzoneOptions(){
      return {}
    }
  },
  computed: {
    dropzoneOptions() {
       return  {
        thumbnailWidth: null,
        maxFilesize: 8,
        action: false,
        url: '/url',
        maxFiles: 20,
        acceptedFiles: 'image/*',
        autoProcessQueue: false,
        addRemoveLinks: true,
        dictRemoveFile: this.$lang('main.crud.remove'),
        autoQueue: false,
        init: function() {
          const self = this;

          self.on("error", function (file, msg, xhr) {
            console.error(msg);
          });
        },
         ...this.additionalDropzoneOptions()
      };
    }
  }
}
